import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from 'sonner';
import { Splash } from './Splash';
import { useUi } from '../../contexts/UiContext';
import { useAppState } from '../../contexts/AppStateContext';
import { TodayPage } from '../../pages/Today';
import { ProgressPage } from '../../pages/Progress';
import { OverviewPage } from '../../pages/Overview';
import { CalendarPage } from '../../pages/Calendar';
import { FamilyPage } from '../../pages/Family';
import { ProfilePage } from '../../pages/Profile';
import { FamilyWizard } from '../../pages/FamilyWizard';
import { SettingsPage } from '../../pages/settings/Settings';
import { MemberDetail } from '../../pages/admin/MemberDetail';
import { DutyReview } from '../../pages/admin/DutyReview';
import { WeekClose } from '../../pages/admin/WeekClose';
import { Sidebar } from './Sidebar';
import { MobileHeader } from './MobileHeader';
import { BottomNav } from './BottomNav';
import { TimerBar } from './TimerBar';
import { WhoAreYou } from './WhoAreYou';
import { TaskDetailSheet } from '../tasks/TaskDetailSheet';
import { OfferSheet } from '../tasks/OfferSheet';
import { ExceptionSheet } from '../tasks/ExceptionSheet';
import { TimerSheet } from '../timer/TimerSheet';
import { ApprovalSheet } from '../review/ApprovalSheet';
import { ManualEntrySheet } from '../progress/ManualEntrySheet';
export function AppShell() {
  const [splash, setSplash] = useState(true);
  const endSplash = useCallback(() => setSplash(false), []);
  return <>
      <AnimatePresence data-id="element-825" data-mp="361p7fkk256c4">{splash && <Splash key="splash" onDone={endSplash} data-id="element-826" data-mp="2rbhwdpwdqplg" />}</AnimatePresence>
      <ShellContent data-id="element-827" data-mp="2r955gn8n94w9" />
    </>;
}
function ShellContent() {
  const {
    tab,
    sub
  } = useUi();
  const {
    isAdmin,
    needsPick
  } = useAppState();
  if (needsPick) return <WhoAreYou data-id="element-828" data-mp="2ibl135fhishf" />;
  let page: React.ReactNode;
  if (sub?.kind === 'member' && isAdmin) page = <MemberDetail memberId={sub.id} data-id="element-829" data-mp="2matw0dm9gwek" />;else if (sub?.kind === 'settings') page = <SettingsPage section={sub.section} data-id="element-830" data-mp="sto8zfl728cq" />;else if (sub?.kind === 'wizard') page = <FamilyWizard data-id="element-831" data-mp="o2fui550bwsp" />;else if (sub?.kind === 'weekClose' && isAdmin) page = <WeekClose data-id="element-832" data-mp="o0cwoyxm4zdf" />;else if (sub?.kind === 'dutyReview' && isAdmin) page = <DutyReview data-id="element-833" data-mp="j44pc7pnqagt" />;else if (sub?.kind === 'profile') page = <ProfilePage data-id="element-834" data-mp="e4jplv2nxy31" />;else if (sub?.kind === 'progress') page = <ProgressPage data-id="element-835" data-mp="e6335dwxpv14" />;else if (tab === 'pregled' && isAdmin) page = <OverviewPage data-id="element-836" data-mp="1bqz54rbj4lny" />;else if (tab === 'koledar') page = <CalendarPage data-id="element-837" data-mp="1bpo1cri33dwu" />;else if (tab === 'napredek' && !isAdmin) page = <ProgressPage data-id="element-838" data-mp="16tgsapue5mao" />;else if (tab === 'druzina') page = <FamilyPage data-id="element-839" data-mp="11tksl2sq8h0x" />;else page = <TodayPage data-id="element-840" data-mp="11st1a465x5gg" />;
  return <div className="min-h-screen w-full bg-canvas font-sans text-ink md:flex" data-id="element-841" data-mp="11vxgrxp2vnmf">
      <Sidebar data-id="element-842" data-mp="xrppptv5dvl1" />
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-843" data-mp="xrzddaspzqnk">
        <MobileHeader data-id="element-844" data-mp="3mkbpi48v5pku" />
        <main className="flex-1 px-4 pb-44 pt-5 md:px-10 md:pb-12 md:pt-10" data-id="element-845" data-mp="3mkv1737x7hqf">
          <div className="mx-auto max-w-6xl" data-id="element-846" data-mp="3ii8aj5mzk2ut">{page}</div>
        </main>
      </div>
      <div className="fixed inset-x-0 bottom-0 z-30 md:hidden" data-id="element-847" data-mp="1y0z7hvxd5php">
        <TimerBar variant="mobile" data-id="element-848" data-mp="1xycql5ol1xmt" />
        <BottomNav data-id="element-849" data-mp="221j4mzhxst3u" />
      </div>
      <TaskDetailSheet data-id="element-850" data-mp="222u3qm0ftcom" />
      <OfferSheet data-id="element-851" data-mp="21zya39vmha5z" />
      <ExceptionSheet data-id="element-852" data-mp="27144rd8uf7i5" />
      <TimerSheet data-id="element-853" data-mp="270vp5dlc5o39" />
      <ApprovalSheet data-id="element-854" data-mp="270c5nsg1ern4" />
      <ManualEntrySheet data-id="element-855" data-mp="26zt0lcbhjxqi" />
      <Toaster position="top-center" toastOptions={{
      style: {
        fontFamily: 'Nunito, sans-serif',
        borderRadius: 16
      }
    }} data-id="element-856" data-mp="2bru6mgi28s83" />
    </div>;
}